import React from 'react';
import { ChevronLeft, Share2 } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button, PageHeader, ShareButton } from '@mts/ui';
import FavoriteButton from './FavoriteButton';

function BasicBackNavControl({ navigationLocked = false }) {
  const navigate = useNavigate();

  const handleBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
      return;
    }

    navigate('/listings');
  };

  return (
    <div id="PageBackNavControl" className="flex items-center">
      <div id="PageBackNavControl-Desktop" className="hidden md:block">
        <PageHeader.Breadcrumbs
          items={[navigationLocked ? { label: 'Back' } : { label: 'Back', href: '/listings' }]}
          className="mb-0"
          aria-label="Back breadcrumb"
        />
      </div>

      <div id="PageBackNavControl-Mobile" className="md:hidden">
        <Button
          type="button"
          variant="ghost"
          size="sm"
          onClick={handleBack}
          disabled={navigationLocked}
          className="inline-flex items-center gap-1"
          aria-label="Back"
        >
          <ChevronLeft size={16} aria-hidden="true" />
          <span>Back</span>
        </Button>
      </div>
    </div>
  );
}

function BasicPageActionRow({ shareData, listingId, isSpotlightTier = false, navigationLocked = false }) {
  if (isSpotlightTier) {
    return null;
  }

  return (
    <div
      id="PageActionRow"
      className="grid grid-cols-[auto,1fr,auto] items-center gap-2 px-0 py-0 sm:px-3 sm:py-2"
      style={{ backgroundColor: 'var(--card)' }}
    >
      <BasicBackNavControl navigationLocked={navigationLocked} />

      <div aria-hidden="true" />

      <div id="PageActionRow-Actions" className="flex items-center gap-2">
        <div
          id="PageActionRow-Save"
          className="inline-flex h-9 items-center gap-1 rounded-md border px-1.5 md:px-2.5 shadow-sm"
          style={{
            borderColor: 'var(--ui-input-border)',
            backgroundColor: 'var(--surface)',
            color: 'var(--page-heading-color)',
          }}
        >
          <FavoriteButton
            id="PageActionRow-FavoriteButton"
            listingId={listingId}
            size={15}
            className="inline-flex h-7 w-7 items-center justify-center rounded-md"
            style={{ color: 'var(--page-heading-color)' }}
          />
          <span className="hidden text-xs font-medium md:inline">Save</span>
        </div>

        {shareData ? <ShareButton {...shareData} variant="ghost"
          id="PageActionRow-Share"
          type="button"
          className="inline-flex h-9 w-9 items-center justify-center gap-1 rounded-md border shadow-sm p-0 md:w-auto md:px-2.5"
          style={{
            borderColor: 'var(--ui-input-border)',
            backgroundColor: 'var(--surface)',
            color: 'var(--page-heading-color)',
          }}
          aria-label="Share listing"
        >
          <Share2 size={15} />
          <span className="hidden text-xs font-medium md:inline">Share</span>
        </ShareButton> : null}
      </div>
    </div>
  );
}

export default BasicPageActionRow;
